import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { Dialog } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { rescheduleMultipleCollectionManagement } from '../../../../../../../../../../../../lib/api/collections';
import CustomButton from '../../../../../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../../../../../lib/designSystem/CircularProgress';
import {
  getShortString,
  showAlert,
} from '../../../../../../../../../../../../lib/functions/utils';

const MultiReschedule = (props: any) => {
  const { open, setOpen, managementsToReschedule, byStakeholder } = props;
  const dispatch = useDispatch();
  const [
    managementsToRescheduleFormatted,
    setManagementsToRescheduleFormatted,
  ] = useState<any[]>([]);
  const [dataForRequest, setDataForRequest] = useState<any>({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleReschedule = () => {
    const payload = {
      managements: managementsToRescheduleFormatted.map((management: any) => {
        return {
          id: management.id,
          dueDate:
            management.dueDate === 'Invalid Date' ? null : management.dueDate,
        };
      }),
    };
    setDataForRequest(payload);
    setOpenConfirmDialog(true);
  };

  const handleConfirmReschedule = async () => {
    setLoading(true);
    try {
      await rescheduleMultipleCollectionManagement(dispatch, dataForRequest);
      showAlert(dispatch, 'success', 'Gestiones reprogramadas correctamente');
      window.location.reload();
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al reprogramar las gestiones');
    }
    setLoading(false);
  };

  const formatManagementsToReschedule = () => {
    const formattedManagements = managementsToReschedule.map(
      (management: any) => {
        return {
          id: management.id,
          folio: management.folio,
          stakeholderName: management.stakeholderName,
          businessName: management.businessName,
          dueDate: dayjs(management.dueDate).format('YYYY-MM-DD'),
        };
      },
    );
    setManagementsToRescheduleFormatted(formattedManagements);
  };

  useEffect(() => {
    formatManagementsToReschedule();
  }, [managementsToReschedule]);

  return (
    <div>
      <Dialog open={open} maxWidth="xl">
        <DialogTitle>Reprogramar gestiones</DialogTitle>
        <DialogContent>
          <Typography marginBottom={2} paddingRight={30}>
            Selecciona la nueva fecha de vencimiento para las gestiones.
          </Typography>
          {managementsToRescheduleFormatted.map((management: any) => (
            <Grid container key={management.id} spacing={2} marginBottom={2}>
              <Grid item xs={8}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '64px',
                  }}
                >
                  <Typography>
                    Folio #{management.folio} |{' '}
                    {getShortString(
                      byStakeholder
                        ? management.businessName
                        : management.stakeholderName,
                      25,
                    )}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '64px',
                  }}
                >
                  <TextField
                    id="outlined-basic-two"
                    label="Nueva fecha de vencimiento"
                    variant="outlined"
                    type="date"
                    value={management.dueDate}
                    fullWidth
                    onChange={(e) => {
                      const newManagements =
                        managementsToRescheduleFormatted.map((m: any) => {
                          if (m.id === management.id) {
                            return {
                              ...m,
                              dueDate: e.target.value,
                            };
                          }
                          return m;
                        });
                      setManagementsToRescheduleFormatted(newManagements);
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          ))}
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setOpen(false)}>
            Cancelar
          </CustomButton>
          <CustomButton color="success" onClick={() => handleReschedule()}>
            Reprogramar
          </CustomButton>
        </DialogActions>
      </Dialog>
      {openConfirmDialog && (
        <Dialog
          open={openConfirmDialog}
          onClose={() => setOpenConfirmDialog(false)}
        >
          <DialogTitle>Confirmar</DialogTitle>
          <DialogContent>
            {loading ? (
              <div style={{ minHeight: '100px' }}>
                <CenteredCircularProgress type="dialog" />
              </div>
            ) : (
              <Typography>
                ¿Estás seguro de querer reprogramar las gestiones?
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <CustomButton
              color="secondary"
              onClick={() => setOpenConfirmDialog(false)}
            >
              Cancelar
            </CustomButton>
            <CustomButton
              color="success"
              onClick={() => handleConfirmReschedule()}
            >
              Confirmar
            </CustomButton>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default MultiReschedule;
